import * as React from "react"
import { cn } from "@/lib/utils"

interface AppleCardProps {
  children: React.ReactNode
  className?: string
}

export function AppleCard({ children, className }: AppleCardProps) {
  return (
    <div className={cn(
      "bg-white dark:bg-apple-dark-gray",
      "rounded-apple-lg p-4",
      "shadow-apple",
      "border border-apple-light-gray dark:border-gray-800",
      className
    )}>
      {children}
    </div>
  )
} 